export default "__VITE_ASSET__ba918a83__"